/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2022-03-28 11:23:53
 * @modify date 2022-03-28 11:23:53
 * @desc 入口文件 plugins 必须第一行
 */
import { getInitial } from '@/plugins';
import lodash from 'lodash';
import React from 'react';
import { dynamic, IRoute } from 'umi';
import './assets/style/index.less';
import { patchRouteMergeLocales } from './components';
import { rewriteConfig } from './microApp';
// window.LenovoIdSyncLoginState = function (lenovoid_wust) {
//     console.log("zhaoyu ~ lenovoid_wust", lenovoid_wust)
// }
rewriteConfig();
/**
 * 初始化数据
 * @export
 * @return {*}
 */
export async function getInitialState() {
  await getInitial();
  return {};
}
/**
 * 路由
 * @export
 * @param {*} { routes }
 */
export function patchRoutes({ routes }: { routes: IRoute[] }) {
  rewriteConfig();
  patchRouteMergeLocales({
    routes,
    pagesContext: require.context('@/pages', true, /locales.ts$/, 'sync'),
  });
  console.log('LENG ~ patchRoutes ~ routes', routes);
  lodash.update(routes, '[0].routes', (child: IRoute[]) => {
    //主要用于小智聊天注册流程
    child.push({
      path: '/chat/*',
      exact: true,
      component: dynamic({
        loader: () => import('./pages/register/index'),
      }),
    });
    //主要用于小智聊天注册流程
    child.push({
      path: '/lenovoit',
      exact: true,
      component: dynamic({
        loader: () => import('./pages/register/index'),
      }),
    });
    //主要用于小智聊天注册流程
    child.push({
      path: '/smallchat',
      exact: true,
      component: dynamic({
        loader: () => import('./pages/register/index'),
      }),
    });
    return child;
  });
}
const lenovo_analytics = lodash.debounce(() => {
  typeof window.lenovo_analytics == 'function' && window.lenovo_analytics();
}, 300);
export function onRouteChange(params) {
  if (!React.AppConfig.develop) {
    lenovo_analytics();
  }
  //  microAppRouteChange(params)
}
declare global {
  interface Window {
    lenovo_analytics: Function;
    // LenovoIdSyncLoginState: any;
  }
}
